import CardListModule from './CardListModule';

export default CardListModule;
